import React, { Component } from "react";
export default class GoogleMaps extends Component {
  render() {
    return (
      <div className="google-maps-section">
        <h2>Map integration</h2>
      </div>
    );
  }
}
